<template>
  <v-card flat sm4>
    <v-container>
      <v-form  @submit.prevent="updatePostPromoCode()">
        <v-layout row wrap>
          <v-flex sm12>
            <v-container>
              <v-dialog
                ref="dialog"
                persistent
                v-model="modal1"
                lazy
                full-width
                width="290px"
                :return-value.sync="promo_code.start_date"
              >
                <v-text-field
                  slot="activator"
                  label="Start Date"
                  v-model="promo_code.start_date"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="promo_code.start_date"
                  :min="start_date"
                  scrollable>
                  <v-spacer></v-spacer>
                  <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                  <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(promo_code.start_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex sm12>
            <v-container>
              <v-dialog
                ref="dialog1"
                persistent
                v-model="modal2"
                lazy
                full-width
                width="290px"
                :return-value.sync="promo_code.end_date"
              >
                <v-text-field
                  slot="activator"
                  label="End Date"
                  v-model="promo_code.end_date"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="promo_code.end_date"
                  :min="promo_code.start_date"
                  scrollable>
                  <v-spacer></v-spacer>
                  <v-btn :depressed="true" flat color="primary" @click="modal2 = false">Cancel</v-btn>
                  <v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(promo_code.end_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg6 md12 sm12 xs12>
            <v-container>
              <v-text-field
                label="Percentage Off (%)"
                v-model="promo_code.percentage_off"
                :rules="requiredRules"
                required
                type="number"
                step="0.01"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md12 sm12 xs12>
            <v-container>
              <v-text-field
                label="Maximum Uses"
                v-model="promo_code.max_uses"
                :rules="requiredRules"
                required
                type="number"
              ></v-text-field>
            </v-container>
          </v-flex>
        </v-layout>
        <v-btn :depressed="true" color="warning" type="submit">Update Promo Code</v-btn>
      </v-form>
    </v-container>
    {{updatePromoCode}}
  </v-card>
</template>

<script>
export default {
  name: 'EditPromoCode',
  data () {
    return {
      active: null,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      edit: false,
      start_date: this.$moment().format('YYYY-MM-DD'),
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      promo_code: {
        public_id: this.$route.params.promo_code_id,
        start_date: '',
        end_date: '',
        percentage_off: '',
        max_uses: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_promo_code', this.$route.params.promo_code_id)
  },
  methods: {
    updatePostPromoCode () {
      this.$store.dispatch('update_promo_code', this.promo_code)
    }
  }
}
</script>

<style scoped>

</style>
